module.exports = __webpack_public_path__ + "14f955c011280252cf5c9994e596ee6b.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/visa.svg
// module id = 479
// module chunks = 73